export default __webpack_public_path__ + "static/media/logoBlue.987713e5.png";